import { BuildRulesetQuery } from '../../../interfaces/Rulesets';

export const selectFields_ruleset100_PIFLV: string = `
    rank, id, product.label, attributes`;

export const order_ruleset100_PIFLV = 'rank DESC, label';

// PIFLV
export const buildQuery_ruleset100_PIFLV: BuildRulesetQuery = ({
    selectFields,
    filter,
    volumetricFlow,
}): [string, string[]] => {
    return [
        `WITH 
    p as (SELECT id, label, attributes FROM product WHERE ${filter}),
    ruleset as (SELECT
                  json_extract(value, '$.rank') AS rank,
                  json_extract(value, '$.min') AS min,
                  json_extract(value, '$.max') AS max,
                  json_extract(value, '$.rec') AS rec
                FROM json_each('[
{ "rank": 2, "min": 276, "max": 320, "rec": "C215QFL-C" },
{ "rank": 2, "min": 320, "max": 518, "rec": "C215QFL-D" },
{ "rank": 2, "min": 518, "max": 716, "rec": "C215QFL-E" },
{ "rank": 2, "min": 716, "max": 1035, "rec": "C215QFL-F0" },
{ "rank": 2, "min": 1035, "max": 1140, "rec": "C215QFL-F" },
{ "rank": 2, "min": 1140, "max": 1235, "rec": "C220QFL-F6" },
{ "rank": 2, "min": 1235, "max": 1321, "rec": "C220QFL-F6" },
{ "rank": 1, "min": 1235, "max": 1321, "rec": "C215QFL-F" },
{ "rank": 2, "min": 1321, "max": 1425, "rec": "C215QFL-F" },
{ "rank": 2, "min": 1425, "max": 1651, "rec": "C220QFL-G0" },
{ "rank": 2, "min": 1651, "max": 2091, "rec": "C220QFL-G" },
{ "rank": 2, "min": 2091, "max": 2586, "rec": "C220QFL-H0" },
{ "rank": 2, "min": 2586, "max": 3191, "rec": "C220QFL-H" },
{ "rank": 2, "min": 3191, "max": 3960, "rec": "R225FL-J" }
]') AS ruleset)
         SELECT ${selectFields}
         FROM ruleset JOIN p AS product ON product.label = ruleset.rec
         WHERE cast(? as float) * 1000 BETWEEN min AND max - 1`,
        [volumetricFlow]
    ];
}
